// extracted by mini-css-extract-plugin
export default {"dialog":"SelectProject_tsx_dialog__d1+0I","container":"SelectProject_tsx_container__eDIBg"};